<template>
    <v-card>
        <s-toolbar label="Cerrar Pallets" dark color="#8e8f91">
            <v-tooltip bottom="">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" small @click="closePallets(selected)">
                    <v-icon style="font-size:16px;">mdi-close-box-multiple</v-icon></v-btn
                    >
                </template>
                <span>Cerrar Pallets</span>
            </v-tooltip>
        </s-toolbar>
        <v-container>
            <v-row>
                <v-col cols="12" md="3">
                    <s-select-definition
                        clearable
                        :def="1181"
                        label="Tipo Destino"
                        v-model="filter.TypeDestine"
                    />
                </v-col>
                <v-col cols="12" md="3">
                    <s-text v-model="filter.Search" label="Buscar" />
                </v-col>
                <v-col cols="12" md="1" style="display: flex; align-items: end;">
                    <v-btn color="primary" @click="search()">Buscar</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-data-table dense 
            item-key="DocEntry" 
            :headers="headers" 
            :items="items" 
            :show-select="true"
            v-model="selected"
        >
            
        </v-data-table>

        <AlertSunshine :dialog="dialogLoad" :totalItems="totalItems" :countItems="countItems" />
    </v-card>
</template>

<script>
import ClosePalletService from '../../../services/FreshProduction/ClosePalletService';

export default {
    data() {
        return {
            items: [],
            headers: [
                { text: "ID", value: "DocEntry" },
                { text: "Línea Empaque", value: "U_SYP_LINEA_EMPAQUE" },
                { text: "Num OP", value: "DocNum" },
                { text: "Plantilla OP", value: "U_SYP_NUMOBMA" },
                { text: "Estatus", value: "status" },
                { text: "Estado", value: "U_SYP_ESTADO" },
                { text: "Fecha Cont.", value: "PostDate" },
                { text: "Fecha Vcnto.", value: "DueDate" },
                { text: "PALETA", value: "BatchNum" },
                { text: "Cod. PT", value: "ItemCode" },
                { text: "Descripción PT", value: "ItemName" },
                { text: "Kg. Planif.", value: "PlannedQty" },
                { text: "Kg. Complet.", value: "CmpltQty" },
                { text: "Comentarios", value: "Comments" },
            ],
            selected: [],
            totalItems: 0,
            countItems: 0,
            dialogLoad: false,
            filter: {
                TypeDestine: 1,
                Search: ""
            }
        }
    },
    methods: {
        closePallets(items) {
            this.totalItems = items.length;
            this.countItems = 0;

            if (items.length == 0) {
                this.$fun.alert("Debe seleccionar al menos un Pallet", "warning");
                return;
            }

            this.$fun.alertFull("¿Seguro de cerrar los pallets?", "question")
                .then(async r => {
                    if (r.value) {
                        this.dialogLoad = true;

                        for (let i = 0; i < items.length; i++) {
                            items[i].ProductionOrderStatus = "boposClosed";
                            console.log('Cerrar pallet:', items[i]);
                            await ClosePalletService.closePallet(items[i], this.$fun.getUserSAPInfo().UsrID, this.$fun.getUserID()).then((response) => {
                                this.countItems++;
                            });
                        }

                        this.dialogLoad = false;
                        this.$fun.alert("Pallets cerrados correctamente", "success");
                    }
                })
        },
        search() {
            if(filter.TypeDestine == 1){
                filter.TypeDestine = 2
            }else if(filter.TypeDestine == 2){
                filter.TypeDestine = 1
            }

            ClosePalletService.list(filter, this.$fun.getUserID()).then((response) => {
                if (response.status == 200){
                    console.log(response);
                    this.items = response.data;
                }
            });
        }
    },
    created() {
        this.search();
    }
}
</script>
